<template>
  <v-container fill-height class="justify-center">
    <v-row justify="center">
      <v-col cols="10" md="6" lg="4" xl="3">
        <v-card
          class="pa-8"
          height="100%"
          width="100%"
          flat
          :disabled="disableCard"
          :elevation="3"
          @click="handleCaptcha()"
        >
          <v-row class="mb-2" justify="center">
            <v-col cols="8">
              <v-img :src="require('@/assets/new_figure.png')" />
            </v-col>
          </v-row>

          <div class="text-h6 font-weight-light text-center">
            Iniciar Novo Atendimento
          </div>
        </v-card>
      </v-col>

      <!--  <v-col cols="10" md="6" lg="4" xl="3">
        <v-card
          class="pa-8"
          height="100%"
          :disabled="disableCard"
          :elevation="3"
          :to="{ name: 'JoinAudience' }"
          flat
        >
          <v-row class="mb-2" justify="center">
            <v-col cols="10">
              <v-img :src="require('@/assets/queue_figure.png')" />
            </v-col>
          </v-row>

          <div class="text-h6 font-weight-light text-center">Audiências</div>

          <div class="text-body-1 font-weight-light text-center mt-n1">
            Entrar no corredor de espera
          </div>
        </v-card>
      </v-col> -->
    </v-row>

    <v-row justify="center">
      <v-col cols="12" md="8" xl="7">
        <div class="text-body-1 font-weight-light text-center">
          Use a opção acima para iniciar um novo atendimento. Este canal foi
          criado para facilitar o contato direto entre cidadãos, advogados(as) e
          o Tribunal de Justiça do Estado da Paraíba.
        </div>
      </v-col>
    </v-row>

    <!-- O Overlay de loading -->
    <LoadingOverlay :loading="loading.overlay" />

    <!-- Dialog de Captcha -->
    <v-dialog v-model="captchaDialog" max-width="19.75rem" persistent>
      <v-card v-if="captchaDialog" class="pa-2">
        <vue-recaptcha
          ref="recaptcha"
          :sitekey="_siteKey"
          @verify="onVerify"
          @expired="onExpired"
        ></vue-recaptcha>
      </v-card>
    </v-dialog>
  </v-container>
</template>

<script>
import { mapState, mapActions } from "vuex";
import { getCounter } from "@/services/counters";
import { handleAlert, formatDocument, showError } from "@/utils";
import { VueRecaptcha } from "vue-recaptcha";
import LoadingOverlay from "@/components/loadingOverlay/LoadingOverlay.vue";

export default {
  name: "Home",

  components: {
    LoadingOverlay,
    VueRecaptcha,
  },

  data() {
    return {
      loading: {
        overlay: false,
      },
      disableCard: false,
      validCaptcha: false,
      captchaDialog: false,
    };
  },

  computed: {
    ...mapState("socket", ["attendance"]),

    _siteKey() {
      return process.env.VUE_APP_GCAPTCHA_PUBLIC_KEY;
    },
  },

  mounted() {
    this.handleQuerys();
  },

  methods: {
    ...mapActions("socket", [
      "createNewAttendance",
      "setAttendance",
      "setMessages",
      "setShouldClearStorage",
    ]),

    ...mapActions(["setPreSelection"]),

    handleCaptcha() {
      this.captchaDialog = true;
      // this.handleStartChat();
    },

    async handleStartChat(chatPath = "/chat-cx") {
      console.log("attendance:new");

      await this.createNewAttendance({
        callback: (error, data) => {
          console.log("createNewAttendance:data", data);

          if (error) {
            console.log("createNewAttendance:error", error);
            throw new Error("Falha ao tentar conectar ao socket. error");
          }

          this.setShouldClearStorage(true);
          this.setMessages([]);
          this.setAttendance(data);

          this.$router.push(chatPath).catch(() => {});
        },
      });
    },

    onVerify(response) {
      if (!response) return (this.captchaDialog = false);
      this.validCaptcha = true;
      this.handleStartChat();
    },

    onExpired() {
      this.validCaptcha = false;
      this.captchaDialog = false;
    },

    async handleQuerys() {
      const query = this.$route.query;

      if (!query || !Object.keys(query).length) return;

      this.loading.overlay = true;

      let payload = {};

      if (query.deskID) {
        try {
          const { data } = await getCounter(query.deskID);

          if (data.isActive) {
            payload = {
              ...(query.deskID && { deskID: query.deskID }),
              ...(query.subgroupID && { subgroupID: query.subgroupID }),
              ...(query.groupID && { groupID: query.groupID }),
              ...(query.chatType && { chatType: query.chatType }),
            };
          }
        } catch {
          /* ignore */
        }
      }

      if (Object.keys(payload).length) {
        await this.setPreSelection(payload);

        this.handleCaptcha();
      }

      this.loading.overlay = false;
    },

    showError,

    handleAlert,

    formatDocument,
  },
};
</script>

<style src="./style.scss" lang="scss" />
